import React from 'react';

const Svgyoutube = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 36 36">
  <g id="Grupo_10981" data-name="Grupo 10981" transform="translate(-20153.001 10043)">

    <path id="_004-youtube" data-name="004-youtube" d="M16.818,76.9c-.632-.751-1.8-1.057-4.025-1.057H4.707c-2.278,0-3.464.326-4.094,1.126C0,77.743,0,78.891,0,80.481v3.03c0,3.079.728,4.643,4.707,4.643h8.085c1.932,0,3-.27,3.694-.933.71-.68,1.013-1.789,1.013-3.71v-3.03C17.5,78.8,17.453,77.649,16.818,76.9Zm-5.583,5.519L7.564,84.333a.564.564,0,0,1-.826-.5V80.007a.565.565,0,0,1,.825-.5l3.672,1.906a.565.565,0,0,1,0,1Z" transform="translate(20162 -10106.838)" fill="#fff"/>
  </g>
</svg>    
  );
};

const Svglinkedin = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 36 36">
  <g id="Grupo_10978" data-name="Grupo 10978" transform="translate(-19978 10039)">

    <g id="_005-linkedin" data-name="005-linkedin" transform="translate(19989 -10029)">
      <path id="Caminho_5920" data-name="Caminho 5920" d="M6.488,159.684H9.622v9.428H6.488Zm0,0" transform="translate(-6.303 -154.774)" fill="#fff"/>
      <path id="Caminho_5921" data-name="Caminho 5921" d="M1.773.5a1.633,1.633,0,1,0-.041,3.258h.02A1.634,1.634,0,1,0,1.773.5Zm0,0" transform="translate(0 -0.5)" fill="#fff"/>
      <path id="Caminho_5922" data-name="Caminho 5922" d="M182.93,151.934a3.111,3.111,0,0,0-2.824,1.556v-1.335h-3.134v9.428h3.134v-5.265a2.148,2.148,0,0,1,.1-.765,1.715,1.715,0,0,1,1.608-1.146c1.134,0,1.587.865,1.587,2.132v5.044h3.133v-5.406C186.538,153.281,184.992,151.934,182.93,151.934Zm0,0" transform="translate(-171.538 -147.245)" fill="#fff"/>
    </g>
  </g>
</svg>
  );
};

const Svgfacebook = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 36 36">
  <g id="Grupo_10980" data-name="Grupo 10980" transform="translate(-20085.999 10043)">

    <path id="_003-facebook" data-name="003-facebook" d="M137,6.187h-3.375V3.938a1.125,1.125,0,0,1,1.125-1.125h1.125V0h-2.25a3.375,3.375,0,0,0-3.375,3.375V6.187H128V9h2.25v9h3.375V9h2.25Z" transform="translate(19972 -10034)" fill="#fff"/>
  </g>
</svg>
  );
};

const Svginstagram = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 36 36">
  <g id="Grupo_10982" data-name="Grupo 10982" transform="translate(-20219 10043)">

    <g id="_001-instagram" data-name="001-instagram" transform="translate(20228 -10034)">
      <path id="Caminho_5918" data-name="Caminho 5918" d="M12.287,0H5.213A5.219,5.219,0,0,0,0,5.213v7.073A5.219,5.219,0,0,0,5.213,17.5h7.073A5.219,5.219,0,0,0,17.5,12.287V5.213A5.219,5.219,0,0,0,12.287,0ZM15.74,12.287a3.453,3.453,0,0,1-3.453,3.453H5.213A3.453,3.453,0,0,1,1.76,12.287V5.213A3.453,3.453,0,0,1,5.213,1.761h7.073A3.453,3.453,0,0,1,15.74,5.213v7.073Z" fill="#fff"/>
      <path id="Caminho_5919" data-name="Caminho 5919" d="M137.234,133a4.234,4.234,0,1,0,4.234,4.234A4.238,4.238,0,0,0,137.234,133Zm0,6.821a2.587,2.587,0,1,1,2.587-2.587A2.587,2.587,0,0,1,137.234,139.821Z" transform="translate(-128.484 -128.484)" fill="#fff"/>
      <ellipse id="Elipse_5" data-name="Elipse 5" cx="1.095" cy="1.095" rx="1.095" ry="1.095" transform="translate(12.183 3.169)" fill="#fff"/>
    </g>
  </g>
</svg>
  );
};

/*
const Svgtiktok = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 36 36">
  <g id="Grupo_10983" data-name="Grupo 10983" transform="translate(-20265 10043)">

    <g id="_006-tik-tok" data-name="006-tik-tok" transform="translate(20275 -10034)">
      <path id="Caminho_5923" data-name="Caminho 5923" d="M47.229,4.9a4.535,4.535,0,0,1-2.74-.916A4.536,4.536,0,0,1,42.677.39H39.738V8.421l0,4.4A2.664,2.664,0,1,1,37.907,10.3V7.311a5.783,5.783,0,0,0-.848-.063,5.636,5.636,0,0,0-4.235,1.894,5.523,5.523,0,0,0,.249,7.616,5.733,5.733,0,0,0,.531.464,5.636,5.636,0,0,0,3.455,1.168,5.783,5.783,0,0,0,.848-.062,5.617,5.617,0,0,0,3.138-1.569A5.5,5.5,0,0,0,42.7,12.843L42.68,6.274a7.447,7.447,0,0,0,4.557,1.549V4.9h-.008Z" transform="translate(-31.423 -0.39)" fill="#fff"/>
    </g>
  </g>
</svg>
  );
};
*/

const WhatsAppLogo = () => {
  return (
<svg fill="#ffffff" height="24px" width="24px" version="1.1" id="Layer_1"  viewBox="0 0 308 308">
<g id="XMLID_468_">
	<path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
		c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
		c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
		c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
		c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
		c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
		c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
		c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
		c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
		C233.168,179.508,230.845,178.393,227.904,176.981z"/>
	<path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
		c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
		c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
		 M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
		l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
		c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
		C276.546,215.678,222.799,268.994,156.734,268.994z"/>
</g>
</svg>
  );
};

const Fale = () => {
  return (
    <div>
      <div id="titulo">
        <h1>Fale com a Criar</h1>
      </div>
      <div id = "texto2">  
      <h2>Telefones:</h2>
      <p>(11) 3615-2500 | Escritório de São Paulo</p>
      <p>(11) 9.9571-4277  | <WhatsAppLogo/> WhatsApp</p>
      <a href="adm@criar.com.br"><b/></a>  
      <h2>Redes Sociais:</h2>
<a href="https://www.youtube.com/@CriarTecnologia-Automaca-vk7wf"><Svgyoutube/></a>
<a href="https://www.instagram.com/criar.tecnologia"><Svginstagram/></a>
<a href="https://www.facebook.com/100078483170409/"><Svgfacebook/></a>
<a href="https://www.linkedin.com/company/criar-tecnologia"><Svglinkedin/></a>     
       
      </div>
    </div>
    )


};

export default Fale;
